var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vxe-column", {
    attrs: {
      type: _vm.cptType,
      field: _vm.prop,
      title: _vm.label,
      width: _vm.width,
      "min-width": _vm.minWidth,
      fixed: _vm.cptFixed,
      align: _vm.align,
      "class-name": _vm.className,
      "show-overflow": _vm.showOverflow,
      formatter: _vm.formatter,
    },
    scopedSlots: _vm._u(
      [
        _vm.$scopedSlots.default
          ? {
              key: "default",
              fn: function (prop) {
                return [
                  _vm._t("default", null, {
                    $table: prop.$table,
                    seq: prop.seq,
                    rowid: prop.rowid,
                    row: prop.row,
                    rowIndex: prop.rowIndex,
                    $rowIndex: prop.$rowIndex,
                    $index: prop.$rowIndex,
                    _rowIndex: prop._rowIndex,
                    column: prop.column,
                    columnIndex: prop.columnIndex,
                    $columnIndex: prop.$columnIndex,
                    _columnIndex: prop._columnIndex,
                    fixed: prop.fixed,
                    type: prop.type,
                    isHidden: prop.isHidden,
                    level: prop.level,
                    visibleData: prop.visibleData,
                    data: prop.data,
                    items: prop.items,
                  }),
                ]
              },
            }
          : null,
        _vm.$scopedSlots.header
          ? {
              key: "header",
              fn: function (prop) {
                return [_vm._t("header", null, { prop: prop })]
              },
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }